module.exports = __webpack_public_path__ + "2d3c42f5973cbb665589438aed33cb35.png";